import React from 'react';

const Services = () => {
    return (
        <div className="container-width py-16">
        <h1 className="text-4xl font-bold mb-8">Our Services</h1>
        <div className="grid md:grid-cols-2 gap-8">
        <div className="bg-white p-6 rounded-lg shadow">
        <h2 className="text-2xl font-semibold mb-4">Tenant Migration</h2>
        <p className="text-gray-600">Complete Microsoft 365 tenant-to-tenant migration with zero downtime.</p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow">
        <h2 className="text-2xl font-semibold mb-4">Data Migration</h2>
        <p className="text-gray-600">Secure migration of all emails, files, and Teams data.</p>
        </div>
        </div>
        </div>
    );
};

export default Services;
